export function getTsFormatDate(timeStamp) {
  var date = new Date(timeStamp);
  // var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();

  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();

  // if (month >= 1 && month <= 9) {
  //   month = "0" + month;
  // }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  if (hours >= 0 && hours <= 9) {
    hours = "0" + hours;
  }
  if (minutes >= 0 && minutes <= 9) {
    minutes = "0" + minutes;
  }
  if (seconds >= 0 && seconds <= 9) {
    seconds = "0" + seconds;
  }
  var currentdate = `${month}月${strDate}日 ${hours}:${minutes}`;
  //或年月日 （注意展示年月日的时候上面的month、strDate、hours、minutes、seconds可不做加0处理）
  //var currentdate = `${year}年${month}月${strDate}日 ${hours}时${minutes}分${seconds}秒`;
  return currentdate;
}

export function formatDuring(time) {
  let days = parseInt(time / (1000 * 60 * 60 * 24));
  let hours = parseInt((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let minutes = parseInt((time % (1000 * 60 * 60)) / (1000 * 60));
  let seconds = parseInt((time % (1000 * 60)) / 1000);
  // 格式 00天 00时 00分 00秒
  if (days < 10) {
    days = "0" + days;
  }
  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  if(hours > 0 ){
    return hours + "小时" +  minutes + "分钟" + seconds + "秒";
  }else{
    return minutes + "分钟" + seconds + "秒";
  }
}
export function nullToEmpty(obj) {
  if (!obj || typeof obj !== 'object') return obj;
  
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] === null || obj[key] === 'null') {
        obj[key] = '';
      } else if (typeof obj[key] === 'object') {
        nullToEmpty(obj[key]); // 递归处理嵌套对象
      }
    }
  }
  return obj;
}

/** 空串转 null，避免后端日期/数字字段解析 "" 失败 */
export function emptyToNull(val) {
  if (val === null || val === undefined || val === "" || val === "null") {
    return null;
  }
  return val;
}

/** 将对象（含嵌套数组）中指定日期字段的空串转为 null */
export function emptyDatesToNull(obj, dateKeys) {
  if (!obj || typeof obj !== "object") return obj;
  const keys = dateKeys || [
    "lxsj",
    "jxsj",
    "foundTime",
    "bsTime",
    "cooperativeTime",
    "achievementStartTime",
    "baseFoundTime",
    "birthday",
  ];
  const keySet = new Set(keys);
  const walk = (node) => {
    if (!node || typeof node !== "object") return;
    if (Array.isArray(node)) {
      node.forEach(walk);
      return;
    }
    Object.keys(node).forEach((key) => {
      const v = node[key];
      if (keySet.has(key) && (v === "" || v === "null")) {
        node[key] = null;
      } else if (v && typeof v === "object") {
        walk(v);
      }
    });
  };
  walk(obj);
  return obj;
}